module.exports = __webpack_public_path__ + "static/media/diagram.5dc48890.png";